import type { Tail } from 'ts-essentials'

import { getCurrentInstance, dialogify as originalDialogify } from '@/util'

export default function useDialogify() {
  const instance = getCurrentInstance()

  function dialogify(...args: Tail<Parameters<typeof originalDialogify>>) {
    return originalDialogify(instance.proxy, ...args)
  }

  return {
    dialogify,
  }
}
